export const COLOR_SCHEMES = Object.freeze(['system', 'light', 'dark']);
export const THEME_STORAGE_KEY = 'statsColorScheme';

export const normalizeColorScheme = (value) => (
    COLOR_SCHEMES.includes(String(value || '').trim().toLowerCase())
        ? String(value).trim().toLowerCase()
        : 'system'
);

export const resolveTheme = (colorScheme, prefersDark = false) => {
    const normalized = normalizeColorScheme(colorScheme);
    return normalized === 'system' ? (prefersDark ? 'dark' : 'light') : normalized;
};

export const readCachedColorScheme = (storage) => {
    try {
        const targetStorage = storage ?? (typeof window !== 'undefined' ? window.localStorage : null);
        return normalizeColorScheme(targetStorage?.getItem(THEME_STORAGE_KEY));
    } catch {
        return 'system';
    }
};

export const cacheColorScheme = (colorScheme, storage) => {
    const normalized = normalizeColorScheme(colorScheme);
    try {
        const targetStorage = storage ?? (typeof window !== 'undefined' ? window.localStorage : null);
        targetStorage?.setItem(THEME_STORAGE_KEY, normalized);
    } catch {
        // Theme persistence is best-effort when storage is unavailable.
    }
    return normalized;
};

export const applyDocumentTheme = (resolvedTheme, root) => {
    const theme = resolvedTheme === 'dark' ? 'dark' : 'light';
    const targetRoot = root ?? (typeof document !== 'undefined' ? document.documentElement : null);
    if (targetRoot) {
        targetRoot.dataset.theme = theme;
        targetRoot.style.colorScheme = theme;
    }
    return theme;
};
